import { render, staticRenderFns } from "./CourseValidationSchema.vue?vue&type=template&id=56b6426b&scoped=true"
import script from "./CourseValidationSchema.vue?vue&type=script&lang=js"
export * from "./CourseValidationSchema.vue?vue&type=script&lang=js"
import style0 from "./CourseValidationSchema.vue?vue&type=style&index=0&id=56b6426b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b6426b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VProgressLinear,VSkeletonLoader})
